import { DashboardT } from 'business/definitions';
import { checkStringMatch } from 'routes/Library/helpers';

export const getSearchBarFilter = (searchValue: string) => (dash: DashboardT) =>
    checkStringMatch(dash.title, searchValue);
